import axios from 'axios';

const { VUE_APP_MODE } = process.env;

let baseURL;
switch (VUE_APP_MODE) {
  case 'prod':
    baseURL = 'https://extapi.zhiyoubao.com';
    break;
  case 'proddev':
    baseURL = 'https://extapi.zhiyoubao.com';
    break;
  case 'test':
    baseURL = 'http://testextapi.sendinfo.com';
    break;
  case 'dev':
    baseURL = '';
    break;
  default:
    baseURL = 'https://extapi.zhiyoubao.com';
}

const http = axios.create({
  baseURL,
  // withCredentials: true,
  headers: { 'content-type': 'application/json;charset=UTF-8' }
});

export default http;
